import { ErrorState } from "@packages/core-client/errors/ErrorState.tsx";
import { ErrorStateBackLink } from "@packages/core-client/errors/ErrorStateBackLink.tsx";
import { useI18nextInstance } from "@squide/i18next";
import { useTranslation } from "react-i18next";
import { assistantI18NextInstanceKey } from "../i18n/i18next.ts";

interface SkillNotFoundProps {
    backHref: string;
}

export function SkillNotFound({ backHref }: SkillNotFoundProps) {
    const i18nextInstance = useI18nextInstance(assistantI18NextInstanceKey);
    const { t } = useTranslation("SkillNotFound", { i18n: i18nextInstance });

    return <ErrorState kind="notFound" ownsPageTitle title={t("heading")} description={t("body")} action={<ErrorStateBackLink href={backHref}>{t("backToSkills")}</ErrorStateBackLink>} />;
}
